import { ProvisioningEnum } from '@lib/resources/types';

export const ACTIVITY_FEED_PROVISONING = [
  ProvisioningEnum.Reminder,
  ProvisioningEnum.Waitlist,
  ProvisioningEnum.Feedback,
  ProvisioningEnum.Referral,
  ProvisioningEnum.OutboundReferral,
  ProvisioningEnum.Broadcast,
  ProvisioningEnum.Scheduler,
  ProvisioningEnum.IntakeForm,
  ProvisioningEnum.PrequalForm,
  ProvisioningEnum.Insurance,
  ProvisioningEnum.Telehealth,
];

export const SCHEDULE_PROVISIONING = [
  ProvisioningEnum.Reminder,
  ProvisioningEnum.Waitlist,
  ProvisioningEnum.Feedback,
  ProvisioningEnum.Followup,
  ProvisioningEnum.Scheduler,
  ProvisioningEnum.PrequalForm,
  ProvisioningEnum.Telehealth,
];

export const REFERRAL_PROVISIONING = ProvisioningEnum.Referral;

export const OUTBOUND_REFERRAL_PROVISIONING = ProvisioningEnum.OutboundReferral;

export const MESSAGE_LIBRARY_PROVISIONING = [ProvisioningEnum.Broadcast, ProvisioningEnum.Chat];

export const CUSTOM_ACTIONS_PROVISIONING = [
  ProvisioningEnum.Recall,
  ProvisioningEnum.Reminder,
  ProvisioningEnum.Followup,
];
